import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import request from '../../../../Helpers/API';
import Swal from 'sweetalert2';
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import { Avatar, Tooltip } from '@mui/material';
import { LoaderScreen } from '../../../components/LoaderScreen';

import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PrintIcon from '@mui/icons-material/Print';
import StarIcon from '@mui/icons-material/Star';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ApartmentIcon from '@mui/icons-material/Apartment';
import EventIcon from '@mui/icons-material/Event';
import AutorenewIcon from '@mui/icons-material/Autorenew';

import { ButtonBack } from '../Util/ButtonBack';
import {
    obtenerTextoEstado,
    obtenerClaseEstado,
    obtenerTextoPrioridad,
    obtenerClasePrioridad,
} from '../../../../Helpers/SeguimientoActEstatus';
import { imprimirTicketPDF } from '../../../../Helpers/imprimirTicketPDF';

// Opciones de estatus para los chips de filtro rápido del toolbar.
// Se definen una sola vez fuera del componente porque son estáticas.
const ESTATUS_OPTIONS = [
    { value: "", label: "Todos" },
    { value: "C", label: "Creado" },
    { value: "P", label: "Proceso" },
    { value: "F", label: "Finalizado" },
    { value: "A", label: "Aceptado" },
    { value: "R", label: "Rechazado" },
    { value: "X", label: "Reactivado" },
];

export const CatSeguimientoActividadesScreen = () => {

    const [usuarioActual, setUsuarioActual] = useState(0);
    const history = useHistory();
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState({ mostrar: false });

    const [filtros, setFiltros] = useState({
        estatus: "",
        prioridad: "",
        texto: "",
        soloMios: false,
        soloResponsable: false
    });

    const [modalCalificacion, setModalCalificacion] = useState(false);
    const [ticketCalificar, setTicketCalificar] = useState(null);
    const [estrellas, setEstrellas] = useState(0);
    const [comentario, setComentario] = useState("");
    const [modoLectura, setModoLectura] = useState(false);
    const [mostrarOpciones, setMostrarOpciones] = useState(true);
    const [motivoReactivar, setMotivoReactivar] = useState("");
    const [loading, setLoading] = useState(false);
    const [mostrarMotivo, setMostrarMotivo] = useState(false);
    const [generandoPDF, setGenerandoPDF] = useState(false);

    const onAgregar = () => history.push("/Permisos/SeguimientoActividadesNueva");

    // Antes mandaba al formulario viejo (SeguimientoActividadesAgregarScreen).
    // Ahora reutiliza el mismo formulario rediseñado del alta (SeguimientoActividadesNuevaScreen),
    // que trae su propio modo de edición cuando recibe un :id por la ruta.
    const onEditar = (id) => {
        history.push(`/Permisos/SeguimientoActividadesNueva/${id}`)
    };

    const verCalificacion = (item) => {
        setTicketCalificar(item);
        setEstrellas(item.calificacion || 0);
        setComentario(item.comentarioCalificacion || "");
        setModoLectura(true);
        setModalCalificacion(true);
    };

    // Genera el PDF del ticket autorizado (campos extra de la sala +
    // quién/cuándo lo autorizó incluidos) usando el helper compartido.
    // El PDF sale rasterizado (imagen, no texto) y con el permiso de
    // edición bloqueado -- ver Helpers/imprimirTicketPDF.js.
    const onImprimir = async (actividad) => {
        try {
            setGenerandoPDF(true);
            await imprimirTicketPDF(actividad);
        } catch (error) {
            console.error("Error generando PDF:", error);
            Swal.fire("Error", "No se pudo generar el PDF del ticket", "error");
        } finally {
            setGenerandoPDF(false);
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return "";
        const f = new Date(fecha);
        return f.toLocaleDateString() + " " + f.toLocaleTimeString();
    };

    const cargarDatos = () => {
        setLoader({ mostrar: true });

        request.get("SeguimientoAct/Listado")
            .then((result) => {
                const datos = result?.data || result;
                setData(Array.isArray(datos) ? datos : []);
            })
            .catch((error) => {
                console.error("ERROR API:", error);
                Swal.fire("LISTADO ACTIVIDADES", "Error al obtener datos", "error");
            })
            .finally(() => setLoader({ mostrar: false }));
    };

    useEffect(() => {
        request.get("SeguimientoAct/UsuarioActual")
            .then(res => {
                const usuario = res?.data?.idUsuario || res?.idUsuario;
                setUsuarioActual(usuario);
            });
        cargarDatos();
    }, []);

    useEffect(() => {
        if (data.length === 0 || usuarioActual === 0) return;

        // "F" = Finalizado (salas Normal) y "A" = Aceptado (salas de
        // Autorización) son los estatus terminales "exitosos" que piden
        // calificación. "R" (Rechazado) se deja fuera a propósito.
        const pendientes = data.filter(item =>
            ["F", "A"].includes(item.estatus) &&
            Number(item.createUser) === Number(usuarioActual) &&
            !item.calificado
        );

        if (pendientes.length > 0) {
            setTicketCalificar(pendientes[0]);
            setModoLectura(false);
            setMostrarOpciones(true);
            setModalCalificacion(true);
        }
    }, [data, usuarioActual]);

    const onEliminar = (id) => {
        Swal.fire({
            title: "¿Eliminar?",
            text: "Esta acción no se puede deshacer",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Eliminar"
        }).then((result) => {
            if (!result.isConfirmed) return;

            request.post("SeguimientoAct/EliminarPorID", id)
                .then(() => {
                    Swal.fire("Eliminado", "Registro eliminado correctamente", "success");
                    cargarDatos();
                })
                .catch((error) => {
                    Swal.fire("Error", error.response?.data?.mensaje || "No se pudo eliminar", "error");
                });
        });
    };

    const reactivarSeguimiento = () => {

        if (!motivoReactivar || motivoReactivar.trim() === "") {
            Swal.fire("Motivo requerido", "Escribe un motivo", "warning");
            return;
        }

        setLoading(true);

        request.post("SeguimientoAct/Reactivar", {
            idSolicitud: ticketCalificar.idSolicitud,
            comentario: motivoReactivar
        })
        .then(() => {
            Swal.fire("Reactivado", "El seguimiento fue reactivado", "success");
            setModalCalificacion(false);
            setMotivoReactivar("");
            cargarDatos();
        })
        .catch((err) => {
            console.log(err.response);
            Swal.fire("Error", err.response?.data?.mensaje || "No se pudo reactivar", "error");
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const enviarCalificacion = () => {
        if (estrellas === 0) {
            Swal.fire("Calificación", "Debes seleccionar estrellas", "warning");
            return;
        }

        if (estrellas < 5 && comentario.trim() === "") {
            Swal.fire("Comentario requerido", "Agrega un comentario si es menor a 5 estrellas", "warning");
            return;
        }

        request.post("SeguimientoAct/Calificar", {
            idSolicitud: ticketCalificar.idSolicitud,
            calificacion: estrellas,
            comentario: comentario
        })
        .then(() => {
            Swal.fire("Gracias", "Calificación enviada", "success");

            setModalCalificacion(false);
            setTicketCalificar(null);
            setEstrellas(0);
            setComentario("");
            setModoLectura(false);

            cargarDatos();
        })
        .catch(() => {
            Swal.fire("Error", "No se pudo guardar la calificación", "error");
        });
    };

    // Limpia todos los filtros a la vez. Se usa tanto desde el link
    // "Limpiar" del toolbar como desde el estado vacío "sin resultados".
    const limpiarFiltros = () => setFiltros({
        estatus: "",
        prioridad: "",
        texto: "",
        soloMios: false,
        soloResponsable: false
    });

    const dataFiltrada = data.filter(item => {

        if (filtros.estatus && item.estatus !== filtros.estatus) return false;
        if (filtros.prioridad && item.prioridad !== filtros.prioridad) return false;
        if (filtros.soloMios && item.createUser !== usuarioActual) return false;
        if (filtros.soloResponsable && item.esResponsable !== 1) return false;

        if (filtros.texto) {
            const texto = filtros.texto.toLowerCase();
            const combinado = `${item.nombreActividad} ${item.comentarios} ${item.nombreSala}`.toLowerCase();
            if (!combinado.includes(texto)) return false;
        }

        return true;
    });

    const hayFiltrosActivos = !!(filtros.estatus || filtros.prioridad || filtros.texto || filtros.soloMios || filtros.soloResponsable);

    return (
        <PlantillaScreen
            titulo={"SEGUIMIENTO DE ACTIVIDADES"}
            className_main={1}
            className={"seguimiento-actividades-contenedor"}
        >

            <ButtonBack path={'/Home/Dashboard'} />
            <LoaderScreen loader={loader} />

            <div className="stp-panel">

                <div className="stp-toolbar">

                    <div className="stp-toolbar-top">
                        <div className="stp-search">
                            <SearchIcon />
                            <input
                                type="text"
                                placeholder="Buscar por actividad, sala o comentario..."
                                value={filtros.texto}
                                onChange={(e) => setFiltros({ ...filtros, texto: e.target.value })}
                            />
                            {filtros.texto && (
                                <CloseIcon
                                    className="stp-search-clear"
                                    onClick={() => setFiltros({ ...filtros, texto: "" })}
                                />
                            )}
                        </div>

                        <div className="stp-toolbar-meta">
                            {dataFiltrada.length} de {data.length} {data.length === 1 ? "ticket" : "tickets"}
                        </div>

                        <button type="button" className="stp-btn-nuevo" onClick={onAgregar}>
                            <AddIcon />
                            Nuevo ticket
                        </button>
                    </div>

                    <div className="stp-toolbar-filtros">

                        <div className="stp-chips">
                            {ESTATUS_OPTIONS.map((op) => (
                                <button
                                    key={op.value || "todos"}
                                    type="button"
                                    className={`stp-chip ${filtros.estatus === op.value ? "is-active" : ""}`}
                                    onClick={() => setFiltros({ ...filtros, estatus: op.value })}
                                >
                                    {op.label}
                                </button>
                            ))}
                        </div>

                        <select
                            className="stp-select"
                            value={filtros.prioridad}
                            onChange={(e) => setFiltros({ ...filtros, prioridad: e.target.value })}
                        >
                            <option value="">Prioridad</option>
                            <option value="A">Alta</option>
                            <option value="M">Media</option>
                            <option value="B">Baja</option>
                        </select>

                        <button
                            type="button"
                            className={`stp-toggle ${filtros.soloMios ? "is-active" : ""}`}
                            onClick={() => setFiltros({ ...filtros, soloMios: !filtros.soloMios })}
                        >
                            Mis tickets
                        </button>

                        <button
                            type="button"
                            className={`stp-toggle ${filtros.soloResponsable ? "is-active" : ""}`}
                            onClick={() => setFiltros({ ...filtros, soloResponsable: !filtros.soloResponsable })}
                        >
                            Soy responsable
                        </button>

                        {hayFiltrosActivos && (
                            <button type="button" className="stp-limpiar" onClick={limpiarFiltros}>
                                <CloseIcon />
                                Limpiar filtros
                            </button>
                        )}
                    </div>

                </div>

                <div className="stp-grid">

                    {data.length === 0 ? (
                        <div className="stp-empty">
                            <div className="stp-empty-titulo">No hay tickets registrados</div>
                            <div className="stp-empty-subtitulo">Crea el primero con el botón "Nuevo ticket"</div>
                        </div>
                    ) : dataFiltrada.length === 0 ? (
                        <div className="stp-empty">
                            <div className="stp-empty-titulo">Sin resultados para estos filtros</div>
                            <div className="stp-empty-subtitulo">Prueba ajustando la búsqueda o los filtros aplicados</div>
                            <button type="button" className="stp-limpiar" onClick={limpiarFiltros}>
                                <CloseIcon />
                                Limpiar filtros
                            </button>
                        </div>
                    ) : (
                        dataFiltrada.map((item) => {

                            const esResponsable = item.esResponsable === 1;
                            const esCreador = item.createUser === usuarioActual;

                            const esCreado = item.estatus === "C";

                            const puedeEditar =
                                esCreado && (esResponsable || esCreador);

                            const puedeEliminar =
                                esCreado && (esResponsable || esCreador);

                            const puedeImprimir =
                                esResponsable && item.estatus === "A"
                                || esResponsable && item.estatus ==! "F";

                            const clasePrioridad = obtenerClasePrioridad(item.prioridad);

                            return (
                                <div
                                    key={item.idSolicitud}
                                    className={`stp-card ${clasePrioridad ? `stp-card--prioridad-${clasePrioridad}` : ""}`}
                                >

                                    <div className="stp-card-header">
                                        <div className="stp-card-user">
                                            <Avatar
                                                src={item.fotoUsuario ? `data:image/jpeg;base64,${item.fotoUsuario}` : ""}
                                                className="stp-avatar"
                                            />

                                            <div>
                                                <div className="stp-usuario-nombre">
                                                    {item.usuarioNombre || "Usuario"}
                                                </div>
                                                <div className="stp-folio">
                                                    Folio: {item.folio || item.idSolicitud}
                                                </div>
                                            </div>
                                        </div>

                                        <span className={`status-badge status-badge--estatus-${obtenerClaseEstado(item.estatus)}`}>
                                            {obtenerTextoEstado(item.estatus)}
                                        </span>
                                    </div>

                                    <div className="stp-card-body">
                                        <div className="stp-title">{item.nombreActividad}</div>

                                        <div className="stp-meta-row">
                                            <span className="stp-meta-item">
                                                <ApartmentIcon /> {item.nombreSala}
                                            </span>
                                            <span className="stp-meta-item">
                                                <EventIcon /> {formatearFecha(item.createDate)}
                                            </span>
                                            {clasePrioridad && (
                                                <span className={`status-badge status-badge--prioridad-${clasePrioridad}`}>
                                                    {obtenerTextoPrioridad(item.prioridad)}
                                                </span>
                                            )}
                                        </div>

                                        {item.comentarios && (
                                            <div className="stp-comentario">{item.comentarios}</div>
                                        )}
                                    </div>

                                    <div className="stp-card-footer">

                                        {esResponsable && (
                                            <Tooltip title="Imprimir">
                                                <button
                                                    type="button"
                                                    className={`stp-icon-btn stp-icon-btn--print ${!puedeImprimir ? "is-disabled" : ""}`}
                                                    onClick={() => onImprimir(item)}
                                                >
                                                    <PrintIcon />
                                                </button>
                                            </Tooltip>
                                        )}

                                        {item.calificado && (
                                            <Tooltip title="Ver calificación">
                                                <button
                                                    type="button"
                                                    className="stp-icon-btn stp-icon-btn--star"
                                                    onClick={() => verCalificacion(item)}
                                                >
                                                    <StarIcon />
                                                </button>
                                            </Tooltip>
                                        )}

                                        <Tooltip title="Ver evidencia">
                                            <button
                                                type="button"
                                                className="stp-icon-btn stp-icon-btn--ver"
                                                onClick={() => history.push(`/Permisos/SeguimientoActividadesCard/${item.idSolicitud}`)}
                                            >
                                                <VisibilityIcon />
                                            </button>
                                        </Tooltip>

                                        {puedeEditar && (
                                            <Tooltip title="Editar">
                                                <button
                                                    type="button"
                                                    className="stp-icon-btn stp-icon-btn--editar"
                                                    onClick={() => onEditar(item.idSolicitud)}
                                                >
                                                    <CreateIcon />
                                                </button>
                                            </Tooltip>
                                        )}

                                        {puedeEliminar && (
                                            <Tooltip title="Eliminar">
                                                <button
                                                    type="button"
                                                    className="stp-icon-btn stp-icon-btn--eliminar"
                                                    onClick={() => onEliminar(item.idSolicitud)}
                                                >
                                                    <DeleteIcon />
                                                </button>
                                            </Tooltip>
                                        )}

                                    </div>

                                </div>
                            );
                        })
                    )}

                </div>

            </div>

            {modalCalificacion && ticketCalificar && (
                <div className="stp-modal-overlay">
                    <div className="stp-modal-card">

                        <div className="stp-modal-header">
                            <span className="stp-modal-header-icon"><StarIcon /></span>
                            <div>
                                <div className="stp-modal-titulo">
                                    {modoLectura
                                        ? "Calificación"
                                        : mostrarMotivo
                                            ? "Reactivación"
                                            : mostrarOpciones
                                                ? "Acciones disponibles"
                                                : "Calificar actividad"}
                                </div>
                                <div className="stp-modal-subtitulo">{ticketCalificar.nombreActividad}</div>
                            </div>
                        </div>

                        <div className="stp-modal-info">
                            <div><span>Folio</span>{ticketCalificar.folio}</div>
                            <div><span>Sala</span>{ticketCalificar.nombreSala}</div>
                        </div>

                        {!modoLectura && mostrarOpciones && (
                            <>
                                {!mostrarMotivo && (
                                    <div className="stp-modal-acciones">
                                        <button
                                            type="button"
                                            className="stp-modal-btn stp-modal-btn--primary"
                                            onClick={() => setMostrarOpciones(false)}
                                        >
                                            Calificar
                                        </button>

                                        <button
                                            type="button"
                                            className="stp-modal-btn stp-modal-btn--secundario"
                                            onClick={() => setMostrarMotivo(true)}
                                        >
                                            Reactivar
                                        </button>
                                    </div>
                                )}

                                {mostrarMotivo && (
                                    <div className="lead-form-group" style={{ marginTop: 16 }}>
                                        <label>Motivo de reactivación</label>
                                        <textarea
                                            rows={3}
                                            value={motivoReactivar}
                                            onChange={(e) => setMotivoReactivar(e.target.value)}
                                        />

                                        <div className="stp-modal-acciones" style={{ marginTop: 10 }}>
                                            <button
                                                type="button"
                                                className="stp-modal-btn stp-modal-btn--primary"
                                                onClick={reactivarSeguimiento}
                                                disabled={loading}
                                            >
                                                Confirmar reactivación
                                            </button>

                                            <button
                                                type="button"
                                                className="stp-modal-btn stp-modal-btn--secundario"
                                                onClick={() => setMostrarMotivo(false)}
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                        {/* CUANDO SE SELECCIONA CALIFICAR */}
                        {!mostrarOpciones && (
                            <>
                                <div className="stp-modal-calificacion">
                                    <span className="stp-modal-label">Calificación</span>

                                    <div className="stp-stars">
                                        {[1, 2, 3, 4, 5].map(n => (
                                            <span
                                                key={n}
                                                className={estrellas >= n ? "active" : ""}
                                                onClick={() => {
                                                    if (modoLectura) return;
                                                    setEstrellas(n);
                                                }}
                                            >
                                                ★
                                            </span>
                                        ))}
                                    </div>
                                </div>

                                {estrellas < 5 && (
                                    <div className="lead-form-group">
                                        <label>Comentario</label>
                                        <textarea
                                            rows={3}
                                            value={comentario}
                                            onChange={(e) => setComentario(e.target.value)}
                                            disabled={modoLectura}
                                        />
                                    </div>
                                )}

                                {!modoLectura && (
                                    <button
                                        type="button"
                                        className="stp-modal-btn stp-modal-btn--primary stp-modal-btn--full"
                                        onClick={enviarCalificacion}
                                    >
                                        Enviar calificación
                                    </button>
                                )}
                            </>
                        )}

                        {/* MODO LECTURA */}
                        {modoLectura && (
                            <button
                                type="button"
                                className="stp-modal-btn stp-modal-btn--primary stp-modal-btn--full"
                                onClick={() => {
                                    setModalCalificacion(false);
                                    setTicketCalificar(null);
                                    setModoLectura(false);
                                }}
                            >
                                Cerrar
                            </button>
                        )}

                    </div>
                </div>
            )}

            {(loading || generandoPDF) && (
                <div className="nsi-loading-overlay">
                    <div className="nsi-loading-card">
                        <div className="nsi-loading-spinner">
                            <span></span>
                            <span></span>
                            <AutorenewIcon />
                        </div>
                        <div className="nsi-loading-titulo">
                            {generandoPDF ? "Generando PDF" : "Reactivando ticket"}
                        </div>
                        <div className="nsi-loading-subtitulo">
                            Un momento, por favor
                            <span className="nsi-loading-dots"><i></i><i></i><i></i></span>
                        </div>
                    </div>
                </div>
            )}

        </PlantillaScreen>
    );
};
